(function () {

  function initCompareSlider() {
    const $container = $(".twentytwenty-container");

    if (!$container.length) return;

    const imgs = $container.find("img");
    let loadedCount = 0;

    imgs.each(function () {
      if (this.complete) {
        loadedCount++;
      } else {
        $(this).on("load", () => {
          loadedCount++;
          if (loadedCount === imgs.length) {
            initTwentyTwenty();
          }
        });
      }
    });

    if (loadedCount === imgs.length) {
      initTwentyTwenty();
    }
  }

  /* 👉 ADD SLIDE LABEL INTO HANDLE */
  function addSlideLabel() {
    document.querySelectorAll(".compare .twentytwenty-handle").forEach((handle) => {
      if (handle.querySelector(".tt-slide-label")) return;

      const label = document.createElement("span");
      label.className = "tt-slide-label";
      label.innerHTML = "<span class='tt-ic'>⇆</span><span class='tt-tx'>SLIDE</span>";
      handle.appendChild(label);
    });
  }

  function initTwentyTwenty() {
    $(".twentytwenty-container").twentytwenty({
      default_offset_pct: 0.5
    });

    /* wait for plugin to build DOM */
    setTimeout(addSlideLabel, 0);
  }

  function destroyAndReinit() {
    const original = $(".twentytwenty-container").clone();
    $(".twentytwenty-wrapper").replaceWith(original);
    initCompareSlider();
  }

  document.addEventListener("DOMContentLoaded", initCompareSlider);
  document.addEventListener("shopify:section:load", initCompareSlider);

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      destroyAndReinit();
    }, 300);
  });

})();
